import { render, staticRenderFns } from "./EditInvoiceItem.vue?vue&type=template&id=b26a38ce&scoped=true&"
import script from "./EditInvoiceItem.vue?vue&type=script&lang=js&"
export * from "./EditInvoiceItem.vue?vue&type=script&lang=js&"
import style0 from "./EditInvoiceItem.vue?vue&type=style&index=0&id=b26a38ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b26a38ce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
